export enum ErrorData {
  Null = 'Данные не получены'
}
